import { useEffect } from "react";
import { scroll2Top } from "../../utils/utils";
import REBienvenueBloc from "../../blocs/retirement/REBienvenueBloc";

export default function REBienvenueRetirementPage() {
    
  useEffect(() => {scroll2Top();}, []);

    return (
      <div className="entreprise-container">
        <div className="ta-center m-y-sm">
          <h2 className="fw-medium bleu fz-xl">Bienvenue sur votre parcours d'affiliation</h2>
          <span className="border-fushia medium m-y-md"></span>
        </div>
        <div className="flex-grid m-lg-desktop">
          <REBienvenueBloc/>
        </div> 
      </div>
    )

}